var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"6f1ca1bd91c7fc7ee3e0c1943c23c71a8d29a6ab"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from "@sentry/nextjs";
import { sentryIgnoreErrorsList } from "@pepdirect/v3/constants";
import {
  environment,
  isProductionReady,
  sentryDSN,
  sentryEnvironment,
} from "config";

const releaseId = process.env.SENTRY_RELEASE;

Sentry.init({
  enabled: isProductionReady,
  dsn: sentryDSN || "",
  environment: sentryEnvironment || environment,
  release: releaseId,
  allowUrls: [
    /https?:\/\/assets\.?production\.decovostatic\.com/,
    /https?:\/\/assets\.?staging\.decovostatic\.com/,
  ],
  // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/filtering/
  ignoreErrors: sentryIgnoreErrorsList,
  enableTracing: false,
  tracesSampleRate: 0,
  beforeSend(event, hint) {
    try {
      if (
        [`<anonymous>`, `/gtm.js`].includes(
          event?.exception?.values?.[0]?.stacktrace?.frames?.[0].filename || ""
        )
      ) {
        return null;
      }
      // eslint-disable-next-line no-empty
    } catch (e) {}

    return event;
  },
});

Sentry.configureScope((scope) => scope.setLevel("error"));
